<template>
    <div ref="cursor" id="vue-cursor" :class="[{hover: isHovering}, {wait: isWaiting}, {inverted: isInverted}]">
        <div ref="innerLoad" class="inner-load"></div>
    </div>
</template>

<script>
    export default {
        mounted() {
            let vm = this;
            setTimeout(function() {
                vm.initCursor();
            }, 1000);
        },
        methods: {
            initCursor() {
                let vm = this;
                let cursor = this.$refs.cursor;
                let reload = true;
                // Center cursor
                gsap.set(cursor, {
                    xPercent: -50,
                    yPercent: -50,
                });
                // Leave/re-enter screen
                document.querySelector('body').addEventListener('mouseleave', (e) => {
                    gsap.to(cursor, {
                        opacity: 0,
                        duration: .35,
                    });
                });
                document.querySelector('body').addEventListener('mouseenter', (e) => {
                    reload = true;
                });
                // Mousemove
                window.addEventListener('mousemove', (e) => {
                    let xCord = e.clientX;
                    let yCord = e.clientY;
                    if(reload === true) {
                        setTimeout(function() {
                            gsap.to(cursor, {
                                opacity: 1,
                                duration: .35,
                            });
                            reload = false;
                        }, 350);
                    }
                    reload = false;
                    gsap.to(cursor, {
                        x: xCord,
                        y: yCord,
                        duration: .5,
                        ease: Power2.easeOut
                    });
                });
                // States
                let hoverLinks = document.querySelectorAll('a[href], [data-link]');
                let clickLinks = document.querySelectorAll('a[href]');
                let invertedBlocks = document.querySelectorAll('[data-invert="true"]');
                let regularBlocks = document.querySelectorAll('[data-invert="false"]');
                
                hoverLinks.forEach(link => {
                    link.addEventListener('mouseover', () => {
                        vm.isHovering = true;
                        link.classList.add('hoveringTarget');
                    });
                    link.addEventListener('mouseleave', () => {
                        vm.isHovering = false;
                        link.classList.remove('hoveringTarget');
                    });
                });
                clickLinks.forEach(link => {
                    link.addEventListener('click', () => {
                        vm.isWaiting = true;
                    });
                });
                invertedBlocks.forEach(invertedBlock => {
                    invertedBlock.addEventListener('mouseover', () => {
                        if(invertedBlock.getAttribute('data-invert') === 'true') {
                            vm.isInverted = true;
                        } else {
                            vm.isInverted = false;
                        }
                    });
                    invertedBlock.addEventListener('mouseenter', () => {
                        if(invertedBlock.getAttribute('data-invert') === 'true') {
                            vm.isInverted = true;
                        } else {
                            vm.isInverted = false;
                        }
                    });
                    invertedBlock.addEventListener('mouseleave', () => {
                        vm.isInverted = false;
                    });
                });
            },
        },
        data() {
            return {
                isHovering: false,
                isWaiting: false,
                isInverted: false,
                // Tilføj til data og opdater når body fancybox is open.
                // hoverLinks = document.querySelectorAll('a[href], [data-link]'),
                // clickLinks = document.querySelectorAll('a[href]'),
                // invertedBlocks = document.querySelectorAll('[data-invert="true"]'),
                // regularBlocks = document.querySelectorAll('[data-invert="false"]')
            }
        },
        watch: {
            isHovering: function(newVal) {
                let cursor = this.$refs.cursor;
                if(newVal == true) {
                    gsap.to(cursor, {
                        scaleX: 1.4,
                        scaleY: 1.4,
                        opacity: 0,
                        duration: .35,
                    });
                } else {
                    gsap.to(cursor, {
                        scaleX: 1,
                        scaleY: 1,
                        opacity: 1,
                        duration: .35,
                    });
                }
            },
            isWaiting: function(newVal) {
                if(newVal == true) {
                    let vm = this;
                    vm.isHovering = false;
                    setTimeout(function() {
                        vm.isWaiting = false;
                    }, 3000);
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    $size: 40px;
    $border-style: 1px solid $black;
    $transition: background-color .35s, border-color .35s;

    body.fancybox-active {
        #vue-cursor {
            z-index: 99999;
            border-color: white !important;
            .inner-load {
                border-color: white !important;
            }
            &[hoverVideo="true"] {
                border-color: rgba(255, 255, 255, 0) !important;
            }
        }
    }
    #vue-cursor {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
        width: $size;
        height: $size;
        border: $border-style;
        border-radius: 50%;
        user-select: none;
        pointer-events: none;
        transition: $transition;
        opacity:0;
        background-color: none;
        @media (pointer: none) {
            display: none;
        }
        @media (hover: none) {
            display: none;
        }
        &.wait {
            .inner-load {
                visibility: visible;
                opacity: 1;
            }
        }
        &.inverted {
            border-color: $white;
            .inner-load {
                border-color: $white;
            }
        }
        .inner-load {
            width: 16px;
            height: 16px;
            visibility: hidden;
            opacity: 0;
            transition: opacity .7s;
            position: absolute;
            top: 0;
            right: 0;
            border-top-right-radius: 99px;
            user-select: none;
            pointer-events: none;
            border: 1px solid $black;
            border-bottom: 0;
            border-left:0;
            margin-top: 3px;
            margin-right: 3px;
            transform-origin: bottom left;
            animation: 1.4s linear infinite rotateCursor;
        }
        @keyframes rotateCursor {
            from {transform: rotate(0);}
            to {transform: rotate(720deg);}
        }
    }
</style>
<style lang="scss">
    .hoveringTarget {}
</style>
